export default __webpack_public_path__ + "static/media/UsersGuide_en.8a079989.md";